import { useAtom } from "jotai";
import { useCallback } from "react";
import {
  menuOpenAtom,
  isOverlayOpenAtom,
  showContextMenuAtom,
  showSubscriptionMenuAtom,
  overlayContentAtom,
  contextMenuPositionAtom,
  filtersMenuTemporaryVisibleAtom,
} from "../../store/atoms/menuAtoms.js";

// Menu State Hook
export const useMenu = () => {
  const [menuOpen, setMenuOpen] = useAtom(menuOpenAtom);
  const [isOverlayOpen, setIsOverlayOpen] = useAtom(isOverlayOpenAtom);
  const [showContextMenu, setShowContextMenu] = useAtom(showContextMenuAtom);
  const [showSubscriptionMenu, setShowSubscriptionMenu] = useAtom(
    showSubscriptionMenuAtom
  );
  const [overlayContent, setOverlayContent] = useAtom(overlayContentAtom);
  const [contextMenuPosition, setContextMenuPosition] = useAtom(
    contextMenuPositionAtom
  );
  const [filtersMenuTemporaryVisible, setFiltersMenuTemporaryVisible] = useAtom(
    filtersMenuTemporaryVisibleAtom
  );

  const toggleMenu = useCallback(
    () => setMenuOpen((prev) => !prev),
    [setMenuOpen]
  );
  const handleOverlayClose = useCallback(
    () => setOverlayContent(null),
    [setOverlayContent]
  );

  return {
    menuOpen,
    setMenuOpen,
    isOverlayOpen,
    setIsOverlayOpen,
    showContextMenu,
    setShowContextMenu,
    showSubscriptionMenu,
    setShowSubscriptionMenu,
    overlayContent,
    setOverlayContent,
    contextMenuPosition,
    setContextMenuPosition,
    filtersMenuTemporaryVisible,
    setFiltersMenuTemporaryVisible,
    toggleMenu,
    handleOverlayClose,
  };
};
